import { render, staticRenderFns } from "./slots.vue?vue&type=template&id=e1ca0146"
import script from "./slots.vue?vue&type=script&lang=js"
export * from "./slots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports